import React from 'react';
import { Helmet } from 'react-helmet-async';
// Import Global Layouts
import BaseLayout from '../../../../layouts/Base';
import { Base } from './styles';

export default function({ children }) {
  return <>
    <Helmet key="helmet">
      <title>Redeem Payout | Berkeley Payment</title>
    </Helmet>
    <BaseLayout key="redeem-body">
      <Base>{children}</Base>
    </BaseLayout>
  </>;
};
